import request from '../../axios';
import {IPostUserOrderDeliveredPayload} from './usePostUserOrderDelivered';

const postUserOrderDelivered = async (
  payload: IPostUserOrderDeliveredPayload,
) => {
  await request.post(`/api/v2/order/user-approve-order-deliver`, payload);
};

export default postUserOrderDelivered;
